import { createContext } from 'react';

const medicationsContext = createContext();

export default medicationsContext;
